import { render, staticRenderFns } from "./WinLose.vue?vue&type=template&id=868220fe&scoped=true"
import script from "./WinLose.vue?vue&type=script&lang=ts"
export * from "./WinLose.vue?vue&type=script&lang=ts"
import style0 from "./WinLose.vue?vue&type=style&index=0&id=868220fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868220fe",
  null
  
)

export default component.exports